export const detailTitles = [
  {
    title: '聯繫電話',
    value: 'residentPhone',
  },
  {
    title: '戶號',
    value: 'householdNumber',
  },
  {
    title: '住戶',
    value: 'residentName',
  },
  {
    title: '登記時間',
    value: 'createdTime',
  },
  {
    title: '預計乘車時間',
    value: 'reservationTime',
  },
  {
    title: '乘車時間',
    value: 'actualCarTime',
  },
  {
    title: '預計下車時間',
    value: 'estimatedArrivalTime',
  },
  {
    title: '下車時間',
    value: 'actualArrivalTime',
  },
  {
    title: '車隊名稱',
    value: 'fleetName',
  },
  {
    title: '車牌',
    value: 'carNumber',
  },
  {
    title: '司機姓名',
    value: 'driverName',
  },
  {
    title: '司機電話',
    value: 'driverPhone',
  },
];
